import {
  actions,
  getContentEntityListsLookupsAsync,
  getContentEntityListsByContentEntityIdAsync,
  getContentEntityListItemsAsync,
  setContentEntityListsItemListAsync,
  getContentEntityListsDatatableAsync,
  createContentEntityListAsync,
  editContentEntityListAsync,
  getContentEntityListByIdAsync,
} from './slices';

export const ContentEntityListsActions = {
  ...actions,
  getContentEntityListsLookupsAsync,
  getContentEntityListsByContentEntityIdAsync,
  getContentEntityListItemsAsync,
  setContentEntityListsItemListAsync,
  getContentEntityListsDatatableAsync,
  createContentEntityListAsync,
  editContentEntityListAsync,
  getContentEntityListByIdAsync,
};

export * from './thunkHandlers';
